import React, { useCallback, useRef } from 'react'
import { InView } from 'react-intersection-observer'
import { useFeaturedProject } from '@/hooks/useFeaturedProject'
import { FeaturedProject } from '@/types/codegen-contentful'
import { FeaturedProjectDisplay } from './FeaturedProjectDisplay'
import { FeaturedProjectPlaceholder } from './FeaturedProjectPlaceholder'

export interface FeaturedProjectSectionProps {
  featuredProjectId: string
  preview?: boolean
  testId?: string
  containerPosition?: number
}
export const FeaturedProjectSection: React.FC<FeaturedProjectSectionProps> = ({
  preview = false,
  featuredProjectId,
  testId,
  containerPosition = 0,
}) => {
  const { featuredProject, federatedContent, loading, error, called, fetchFeaturedProject } = useFeaturedProject({
    featuredProjectId,
    preview,
  })

  const hasFetchedRef = useRef(false)

  const handleInViewChange = useCallback(
    (inView: boolean) => {
      if (inView && !hasFetchedRef.current) {
        fetchFeaturedProject()
        hasFetchedRef.current = true
      }
    },
    [fetchFeaturedProject],
  )

  if (called && !loading && !error && !featuredProject) {
    return null
  }

  return (
    <InView onChange={handleInViewChange} triggerOnce threshold={0.1} rootMargin="400px">
      <section id="featured" data-testid={testId ?? featuredProjectId} aria-busy={loading ? 'true' : 'false'}>
        {(loading || (!!error && !featuredProject)) && <FeaturedProjectPlaceholder />}

        {featuredProject && (
          <div className="animate-fadein">
            <FeaturedProjectDisplay
              featuredProject={featuredProject as FeaturedProject}
              containerPosition={containerPosition}
              federatedContent={federatedContent}
            />
          </div>
        )}
      </section>
    </InView>
  )
}
